import * as normalize from 'utils/normalize';
import getInsuranceType from 'utils/print/getInsuranceType';
import getPatientName from 'utils/print/getPatientName';
import getPatientAddress from 'utils/print/getPatientAddress';
import getPatientCity from 'utils/print/getPatientCity';
import getPatientState from 'utils/print/getPatientState';
import getPatientZip from 'utils/print/getPatientZip';
import getPatientPhone1 from 'utils/print/getPatientPhone1';
import getPatientPhone2 from 'utils/print/getPatientPhone2';
import getPatientPhone3 from 'utils/print/getPatientPhone3';
import getPatientDob1 from 'utils/print/getPatientDob1';
import getPatientDob2 from 'utils/print/getPatientDob2';
import getPatientDob3 from 'utils/print/getPatientDob3';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientRecordNumber from 'utils/print/getPatientRecordNumber';
import getInsuranceSignatureOnFile from 'utils/print/getInsuranceSignatureOnFile';
import getInsuranceRelationToInsured from 'utils/print/getInsuranceRelationToInsured';
import getInsuranceInsuredsID from 'utils/print/getInsuranceInsuredsID';
import getInsuranceInsuredsName from 'utils/print/getInsuranceInsuredsName';
import getInsuranceInsuredsAddress from 'utils/print/getInsuranceInsuredsAddress';
import getInsuranceInsuredsCity from 'utils/print/getInsuranceInsuredsCity';
import getInsuranceInsuredsState from 'utils/print/getInsuranceInsuredsState';
import getInsuranceInsuredsZip from 'utils/print/getInsuranceInsuredsZip';
import getInsuranceInsuredsPhone1 from 'utils/print/getInsuranceInsuredsPhone1';
import getInsuranceInsuredsPhone2 from 'utils/print/getInsuranceInsuredsPhone2';
import getInsuranceInsuredsPhone3 from 'utils/print/getInsuranceInsuredsPhone3';
import getInsuranceInsuredsDob1 from 'utils/print/getInsuranceInsuredsDob1';
import getInsuranceInsuredsDob2 from 'utils/print/getInsuranceInsuredsDob2';
import getInsuranceInsuredsDob3 from 'utils/print/getInsuranceInsuredsDob3';
import getInsuranceInsuredsGender from 'utils/print/getInsuranceInsuredsGender';
import getInsuranceAccidentDate1 from 'utils/print/getInsuranceAccidentDate1';
import getInsuranceAccidentDate2 from 'utils/print/getInsuranceAccidentDate2';
import getInsuranceAccidentDate3 from 'utils/print/getInsuranceAccidentDate3';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getOrderLineDosFrom1 from 'utils/print/getOrderLineDosFrom1';
import getOrderLineDosFrom2 from 'utils/print/getOrderLineDosFrom2';
import getOrderLineDosFrom3 from 'utils/print/getOrderLineDosFrom3';
import getOrderLineDosTo1 from 'utils/print/getOrderLineDosTo1';
import getOrderLineDosTo2 from 'utils/print/getOrderLineDosTo2';
import getOrderLineDosTo3 from 'utils/print/getOrderLineDosTo3';
import getOrderLinePlaceOfService from 'utils/print/getOrderLinePlaceOfService';
import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineModifiers1 from 'utils/print/getOrderLineModifiers1';
import getOrderLineModifiers2 from 'utils/print/getOrderLineModifiers2';
import getOrderLineModifiers3 from 'utils/print/getOrderLineModifiers3';
import getOrderLineModifiers4 from 'utils/print/getOrderLineModifiers4';
import getOrderLineTotalCharge from 'utils/print/getOrderLineTotalCharge';
import getOrderLineDiagnosisPointer from 'utils/print/getOrderLineDiagnosisPointer';
import getOrderLineNarrative from 'utils/print/getOrderLineNarrative';
import getOrderTotalCharge from 'utils/print/getOrderTotalCharge';
import getFacilityNameAndAddress from 'utils/print/getFacilityNameAndAddress';
import getBusinessNPI from 'utils/print/getBusinessNPI';
import getBusinessNameAndAddress from 'utils/print/getBusinessNameAndAddress';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getOrderLineDosFrom from 'utils/print/getOrderLineDosFrom';
import getDefault from 'utils/print/getDefault';
import getOrderAuthorization from 'utils/print/getOrderAuthorization';
import getOrderResubmission from 'utils/print/getOrderResubmission';
import getOrderOriginalRefNumber from 'utils/print/getOrderOriginalRefNumber';
import getInquiringProviderUserName from 'utils/print/getInquiringProviderUserName';
import getInquiringProviderTaxID from 'utils/print/getInquiringProviderTaxID';
import getInsuranceTradingPartnerName from 'utils/print/getInsuranceTradingPartnerName';
import getConditionEmployment from 'utils/print/getConditionEmployment';
import getConditionAutoAccident from 'utils/print/getConditionAutoAccident';
import getConditionAutoAccidentState from 'utils/print/getConditionAutoAccidentState';

const Form1500 = {
  ID: 12,
  Name: '1500 Form',
  Type: 'Form 1500',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 6,
  WithCharge: true,
  WithBackgroundTemplate: true,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Form1500/1.js',
      fields: [
        {
          name: 'Insurance Name',
          type: 'text',
          getValue: getInsuranceTradingPartnerName,
          x: 90,
          y: 12,
          width: 115,
          height: 10,
          multiline: true,
        },
        {
          name: 'Insurance Type',
          type: 'radio',
          getValue: getInsuranceType,
          options: [
            {
              x: 7,
              y: 37.5,
              width: 4,
              height: 4,
              value: '5',
            },
            {
              x: 24.5,
              y: 37.5,
              width: 4,
              height: 4,
              value: '4',
            },
            {
              x: 42.5,
              y: 37.5,
              width: 4,
              height: 4,
              value: '8',
            },
            {
              x: 65,
              y: 37.5,
              width: 4,
              height: 4,
              value: '9',
            },
            {
              x: 83,
              y: 37.5,
              width: 4,
              height: 4,
              value: '10',
            },
            {
              x: 103,
              y: 37.5,
              width: 4,
              height: 4,
              value: 'Feca Blklung',
            },
            {
              x: 118.5,
              y: 37.5,
              width: 4,
              height: 4,
              value: '1',
            },
          ],
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 8,
          y: 45.25,
          width: 71,
        },
        {
          name: 'Patient Address',
          type: 'text',
          getValue: props => getPatientAddress({ ...props, billing: true }),
          x: 8,
          y: 53.5,
          width: 71,
        },
        {
          name: 'Patient City',
          type: 'text',
          getValue: props => getPatientCity({ ...props, billing: true }),
          x: 8,
          y: 62,
          width: 61,
        },
        {
          name: 'Patient State',
          type: 'text',
          getValue: props => getPatientState({ ...props, billing: true }),
          x: 71,
          y: 62,
          width: 8,
        },
        {
          name: 'Patient Zip',
          type: 'text',
          getValue: props => getPatientZip({ ...props, billing: true }),
          x: 8,
          y: 71,
          width: 31,
          maxLength: 5,
          normalize: normalize.number,
        },
        {
          name: 'Patient Phone 1',
          type: 'text',
          getValue: getPatientPhone1,
          x: 43,
          y: 71,
          width: 7.5,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Phone 2',
          type: 'text',
          getValue: getPatientPhone2,
          x: 53,
          y: 71,
          width: 7.5,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Patient Phone 3',
          type: 'text',
          getValue: getPatientPhone3,
          x: 62,
          y: 71,
          width: 12,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 1',
          type: 'text',
          getValue: getPatientDob1,
          x: 81,
          y: 45.25,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 2',
          type: 'text',
          getValue: getPatientDob2,
          x: 90.5,
          y: 45.25,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient DOB 3',
          type: 'text',
          getValue: getPatientDob3,
          x: 99,
          y: 45.25,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Patient Gender',
          type: 'radio',
          getValue: getPatientGender,
          options: [
            {
              x: 111,
              y: 46,
              width: 4,
              height: 4,
              value: 'M',
            },
            {
              x: 123.5,
              y: 46,
              width: 4,
              height: 4,
              value: 'F',
            },
          ],
        },
        {
          name: 'Patient relationship to insured',
          type: 'radio',
          getValue: getInsuranceRelationToInsured,
          options: [
            {
              x: 88,
              y: 55,
              width: 4,
              height: 4,
              value: 'Self',
            },
            {
              x: 101,
              y: 55,
              width: 4,
              height: 4,
              value: 'Spouse',
            },
            {
              x: 111,
              y: 55,
              width: 4,
              height: 4,
              value: 'Child',
            },
            {
              x: 123.5,
              y: 55,
              width: 4,
              height: 4,
              value: 'Other',
            },
          ],
        },
        {
          name: 'Reserved for nucc use',
          type: 'text',
          x: 81,
          y: 61,
          width: 49,
          height: 15.3,
          multiline: true,
        },
        {
          name: 'Other Insuredes Name',
          type: 'text',
          x: 8,
          y: 79,
          width: 71,
        },
        {
          name: 'Other Insuredes Police or Group Number a)',
          type: 'text',
          x: 8,
          y: 87.5,
          width: 71,
        },
        {
          name: 'Other Insuredes Police or Group Number b)',
          type: 'text',
          x: 8,
          y: 96,
          width: 71,
        },
        {
          name: 'Other Insuredes Police or Group Number c)',
          type: 'text',
          x: 8,
          y: 104.5,
          width: 71,
        },
        {
          name: 'Other Insuredes Police or Group Number d)',
          type: 'text',
          x: 8,
          y: 113,
          width: 71,
        },
        {
          name: 'Is Patients condition related to a)',
          type: 'radio',
          getValue: getConditionEmployment,
          options: [
            {
              x: 93,
              y: 88.5,
              width: 4,
              height: 4,
              value: 'Yes',
            },
            {
              x: 108,
              y: 88.5,
              width: 4,
              height: 4,
              value: 'No',
            },
          ],
        },
        {
          name: 'Is Patients condition related to b)',
          type: 'radio',
          getValue: getConditionAutoAccident,
          options: [
            {
              x: 93,
              y: 97,
              width: 4,
              height: 4,
              value: 'Yes',
            },
            {
              x: 108,
              y: 97,
              width: 4,
              height: 4,
              value: 'No',
            },
          ],
        },
        {
          name: 'Is Patients condition related to b) State',
          type: 'text',
          getValue: getConditionAutoAccidentState,
          x: 118.5,
          y: 95.5,
          width: 7,
          maxLength: 2,
        },
        {
          name: 'Is Patients condition related to c)',
          type: 'radio',
          getValue: props => getDefault({ ...props, defaultValue: 'No' }),
          options: [
            {
              x: 93,
              y: 105,
              width: 4,
              height: 4,
              value: 'Yes',
            },
            {
              x: 108,
              y: 105,
              width: 4,
              height: 4,
              value: 'No',
            },
          ],
        },
        {
          name: 'Claim codes',
          type: 'text',
          x: 81,
          y: 113,
          width: 49,
        },
        {
          name: 'Insureds ID Number',
          type: 'text',
          getValue: getInsuranceInsuredsID,
          x: 132,
          y: 37.5,
          width: 75,
        },
        {
          name: 'Insureds Name',
          type: 'text',
          getValue: getInsuranceInsuredsName,
          x: 132,
          y: 45.5,
          width: 75,
        },
        {
          name: 'Insureds Address',
          type: 'text',
          getValue: getInsuranceInsuredsAddress,
          x: 132,
          y: 53.5,
          width: 75,
        },
        {
          name: 'Insureds City',
          type: 'text',
          getValue: getInsuranceInsuredsCity,
          x: 132,
          y: 62,
          width: 58,
        },
        {
          name: 'Insureds State',
          type: 'text',
          getValue: getInsuranceInsuredsState,
          x: 193,
          y: 62,
          width: 14,
        },
        {
          name: 'Insureds Zip',
          type: 'text',
          getValue: getInsuranceInsuredsZip,
          x: 132,
          y: 71,
          width: 31,
          maxLength: 5,
          normalize: normalize.number,
        },
        {
          name: 'Insureds Phone 1',
          type: 'text',
          getValue: getInsuranceInsuredsPhone1,
          x: 170,
          y: 71,
          width: 9,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Insureds Phone 2',
          type: 'text',
          getValue: getInsuranceInsuredsPhone2,
          x: 180,
          y: 71,
          width: 8,
          maxLength: 3,
          normalize: normalize.number,
        },
        {
          name: 'Insureds Phone 3',
          type: 'text',
          getValue: getInsuranceInsuredsPhone3,
          x: 189,
          y: 71,
          width: 12,
          maxLength: 4,
          normalize: normalize.number,
        },
        {
          name: 'Insureds Policy Group or FECA Number',
          type: 'text',
          x: 132,
          y: 79,
          width: 75,
        },
        {
          name: 'Insureds DOB 1',
          type: 'text',
          getValue: getInsuranceInsuredsDob1,
          x: 139,
          y: 88,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Insureds DOB 2',
          type: 'text',
          getValue: getInsuranceInsuredsDob2,
          x: 147,
          y: 88,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Insureds DOB 3',
          type: 'text',
          getValue: getInsuranceInsuredsDob3,
          x: 155,
          y: 88,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Insureds Gender',
          type: 'radio',
          getValue: getInsuranceInsuredsGender,
          options: [
            {
              x: 177,
              y: 88.5,
              width: 4,
              height: 4,
              value: 'M',
            },
            {
              x: 195,
              y: 88.5,
              width: 4,
              height: 4,
              value: 'F',
            },
          ],
        },
        {
          name: 'Insurance Other claim ID',
          type: 'text',
          x: 132,
          y: 96.5,
          width: 75,
        },
        {
          name: 'Insurance Plan name or Program name',
          type: 'text',
          getValue: getInsuranceTradingPartnerName,
          x: 132,
          y: 104.5,
          width: 75,
        },
        {
          name: 'Is there another health benefit plan?',
          type: 'radio',
          getValue: props => getDefault({ ...props, defaultValue: 'N' }),
          options: [
            {
              x: 136,
              y: 113.5,
              width: 4,
              height: 4,
              value: 'Y',
            },
            {
              x: 149,
              y: 113.5,
              width: 4,
              height: 4,
              value: 'N',
            },
          ],
        },
        {
          name: '12 signed',
          type: 'text',
          getValue: getInsuranceSignatureOnFile,
          x: 20,
          y: 129,
          width: 63,
        },
        {
          name: '12 date',
          type: 'text',
          getValue: props => getOrderLineDosFrom({ ...props, index: 0 }),
          x: 97,
          y: 129,
          width: 33,
          normalize: normalize.date,
        },
        {
          name: '13 signed',
          type: 'text',
          getValue: getInsuranceSignatureOnFile,
          x: 146,
          y: 129,
          width: 60,
        },
        {
          name: 'Date of current illness 1',
          type: 'text',
          getValue: getInsuranceAccidentDate1,
          x: 9.5,
          y: 138.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date of current illness 2',
          type: 'text',
          getValue: getInsuranceAccidentDate2,
          x: 17,
          y: 138.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date of current illness 3',
          type: 'text',
          getValue: getInsuranceAccidentDate3,
          x: 24.5,
          y: 138.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date of current illness qual',
          type: 'text',
          x: 45,
          y: 138.5,
          width: 29,
        },
        {
          name: 'Other date qual',
          type: 'text',
          x: 83,
          y: 138.5,
          width: 9,
        },
        {
          name: 'Other Date 1',
          type: 'text',
          x: 98,
          y: 138.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Other Date 2',
          type: 'text',
          x: 106,
          y: 138.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Other Date 3',
          type: 'text',
          x: 114,
          y: 138.5,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date patient unable to work in current occupation From 1',
          type: 'text',
          x: 142,
          y: 138.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date patient unable to work in current occupation From 2',
          type: 'text',
          x: 149,
          y: 138.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date patient unable to work in current occupation From 3',
          type: 'text',
          x: 157,
          y: 138.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date patient unable to work in current occupation To 1',
          type: 'text',
          x: 178,
          y: 138.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date patient unable to work in current occupation To 2',
          type: 'text',
          x: 185,
          y: 138.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Date patient unable to work in current occupation To 3',
          type: 'text',
          x: 192,
          y: 138.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Name of referring provider or other source prefix',
          type: 'text',
          getValue: props => getDefault({ ...props, defaultValue: 'DN' }),
          x: 7.5,
          y: 147,
          width: 6,
        },
        {
          name: 'Name of referring provider or other source',
          type: 'text',
          getValue: getPrescriberName,
          x: 14.5,
          y: 147,
          width: 59,
        },
        {
          name: 'Name of referring provider or other source a)',
          type: 'text',
          x: 87,
          y: 143,
          width: 44,
        },
        {
          name: 'Name of referring provider or other source b)',
          type: 'text',
          getValue: getPrescriberNPI,
          x: 87,
          y: 147,
          width: 44,
        },
        {
          name: 'Hospitalization dates related to current services From 1',
          type: 'text',
          x: 142,
          y: 147.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Hospitalization dates related to current services From 2',
          type: 'text',
          x: 149,
          y: 147.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Hospitalization dates related to current services From 3',
          type: 'text',
          x: 157,
          y: 147.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Hospitalization dates related to current services To 1',
          type: 'text',
          x: 178,
          y: 147.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Hospitalization dates related to current services To 2',
          type: 'text',
          x: 185,
          y: 147.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Hospitalization dates related to current services To 3',
          type: 'text',
          x: 192,
          y: 147.5,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Additional claim information',
          type: 'text',
          x: 8,
          y: 155,
          width: 122,
        },
        {
          name: 'Outside lab?',
          type: 'radio',
          getValue: props => getDefault({ ...props, defaultValue: 'N' }),
          options: [
            {
              x: 136.5,
              y: 156,
              width: 4,
              height: 4,
              value: 'Y',
            },
            {
              x: 149.5,
              y: 156,
              width: 4,
              height: 4,
              value: 'N',
            },
          ],
        },
        {
          name: 'Outside lab charges 1',
          type: 'text',
          x: 161,
          y: 155,
          width: 23,
        },
        {
          name: 'Outside lab charges 2',
          type: 'text',
          x: 186,
          y: 155,
          width: 21,
        },
        {
          name: 'ICD Ind',
          type: 'text',
          getValue: props => getDefault({ ...props, defaultValue: '0' }),
          x: 112,
          y: 160,
          width: 4,
        },
        {
          name: 'Diagnosis a)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 0 }),
          x: 12,
          y: 164,
          width: 17,
        },
        {
          name: 'Diagnosis b)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 1 }),
          x: 46,
          y: 164,
          width: 17,
        },
        {
          name: 'Diagnosis c)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 2 }),
          x: 79,
          y: 164,
          width: 17,
        },
        {
          name: 'Diagnosis d)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 3 }),
          x: 112,
          y: 164,
          width: 17,
        },
        {
          name: 'Diagnosis e)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 4 }),
          x: 12,
          y: 168.5,
          width: 17,
        },
        {
          name: 'Diagnosis f)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 5 }),
          x: 46,
          y: 168.5,
          width: 17,
        },
        {
          name: 'Diagnosis g)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 6 }),
          x: 79,
          y: 168.5,
          width: 17,
        },
        {
          name: 'Diagnosis h)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 7 }),
          x: 112,
          y: 168.5,
          width: 17,
        },
        {
          name: 'Diagnosis i)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 8 }),
          x: 12,
          y: 172.5,
          width: 17,
        },
        {
          name: 'Diagnosis j)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 9 }),
          x: 46,
          y: 172.5,
          width: 17,
        },
        {
          name: 'Diagnosis k)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 10 }),
          x: 79,
          y: 172.5,
          width: 17,
        },
        {
          name: 'Diagnosis l)',
          type: 'text',
          getValue: props => getDiagnosisCode({ ...props, index: 11 }),
          x: 112,
          y: 172.5,
          width: 17,
        },
        {
          name: 'Resubmission',
          type: 'text',
          getValue: props => getOrderResubmission(props),
          x: 132,
          y: 164.5,
          width: 27,
        },
        {
          name: 'Original ref no',
          type: 'text',
          getValue: props => getOrderOriginalRefNumber(props),
          x: 161,
          y: 164.5,
          width: 46,
        },
        {
          name: 'Prior authorization number',
          type: 'text',
          getValue: props => getOrderAuthorization(props),
          x: 132,
          y: 172,
          width: 75,
        },
        ...[0, 1, 2, 3, 4, 5].reduce((accumulator, currentValue) => {
          const y = 189.5 + (currentValue * 8.4);
          return [
            ...accumulator,
            {
              name: `Narrative ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineNarrative({ ...props, index: currentValue }),
              x: 7,
              y: y - 4.2,
              width: 160,
            },
            {
              name: `Date of Service From 1 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDosFrom1({ ...props, index: currentValue }),
              x: 7,
              y,
              width: 7,
              maxLength: 2,
              normalize: normalize.number,
            },
            {
              name: `Date of Service From 2 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDosFrom2({ ...props, index: currentValue }),
              x: 14,
              y,
              width: 7,
              maxLength: 2,
              normalize: normalize.number,
            },
            {
              name: `Date of Service From 3 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDosFrom3({ ...props, index: currentValue }),
              x: 22,
              y,
              width: 7,
              maxLength: 2,
              normalize: normalize.number,
            },
            {
              name: `Date of Service To 1 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDosTo1({ ...props, index: currentValue }),
              x: 29,
              y,
              width: 7,
              maxLength: 2,
              normalize: normalize.number,
            },
            {
              name: `Date of Service To 2 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDosTo2({ ...props, index: currentValue }),
              x: 37,
              y,
              width: 7,
              maxLength: 2,
              normalize: normalize.number,
            },
            {
              name: `Date of Service To 3 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDosTo3({ ...props, index: currentValue }),
              x: 45,
              y,
              width: 7,
              maxLength: 2,
              normalize: normalize.number,
            },
            {
              name: `Place of Service ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLinePlaceOfService({ ...props, index: currentValue }),
              x: 52.5,
              y,
              width: 7,
              normalize: normalize.number,
            },
            {
              name: `EMG ${currentValue}`,
              type: 'text',
              x: 60,
              y,
              width: 7,
            },
            {
              name: `HCPCS C ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 69,
              y,
              width: 17,
              maxLength: 5,
            },
            {
              name: `Modifiers 1 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineModifiers1({ ...props, index: currentValue }),
              x: 87,
              y,
              width: 7,
              maxLength: 2,
            },
            {
              name: `Modifiers 2 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineModifiers2({ ...props, index: currentValue }),
              x: 96,
              y,
              width: 7,
              maxLength: 2,
            },
            {
              name: `Modifiers 3 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineModifiers3({ ...props, index: currentValue }),
              x: 103,
              y,
              width: 7,
              maxLength: 2,
            },
            {
              name: `Modifiers 4 ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineModifiers4({ ...props, index: currentValue }),
              x: 111,
              y,
              width: 7,
              maxLength: 2,
            },
            {
              name: `Diagnosis pointer ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDiagnosisPointer({ ...props, index: currentValue }),
              x: 118.5,
              y,
              width: 12,
            },
            {
              name: `Charge Dollars ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineTotalCharge({ ...props, index: currentValue, part: 'dollars', caloricUnitsSupport: true }),
              x: 131,
              y,
              width: 15,
              textAlign: 'right',
              normalize: normalize.number,
              chargeField: true,
            },
            {
              name: `Charge Cents ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineTotalCharge({ ...props, index: currentValue, part: 'cents', caloricUnitsSupport: true }),
              x: 147.5,
              y,
              width: 6,
              maxLength: 2,
              normalize: normalize.number,
              chargeField: true,
            },
            {
              name: `Qty ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue, caloricUnitsSupport: true }),
              x: 154,
              y,
              width: 9,
            },
            {
              name: `Family plan ${currentValue}`,
              type: 'text',
              x: 164,
              y,
              width: 5,
            },
            {
              name: `Rendering provider ${currentValue}`,
              type: 'text',
              x: 177,
              y,
              width: 30,
            },
          ];
        }, []),
        {
          name: 'Federal Tax ID Number',
          type: 'text',
          getValue: getInquiringProviderTaxID,
          x: 8,
          y: 240,
          width: 37,
        },
        {
          name: 'Federal Tax ID Number Type',
          type: 'radio',
          getValue: props => getDefault({ ...props, defaultValue: 'EIN' }),
          options: [
            {
              x: 48,
              y: 240.5,
              width: 4,
              height: 4,
              value: 'SSN',
            },
            {
              x: 53,
              y: 240.1,
              width: 4,
              height: 4,
              value: 'EIN',
            },
          ],
        },
        {
          name: 'Patients Account No',
          type: 'text',
          getValue: getPatientRecordNumber,
          x: 63,
          y: 240,
          width: 36,
        },
        {
          name: 'Accept assignment?',
          type: 'radio',
          getValue: props => getDefault({ ...props, defaultValue: 'Yes' }),
          options: [
            {
              x: 101,
              y: 240.5,
              width: 4,
              height: 4,
              value: 'Yes',
            },
            {
              x: 114,
              y: 240.1,
              width: 4,
              height: 4,
              value: 'No',
            },
          ],
        },
        {
          name: 'Total charge dollars',
          type: 'text',
          getValue: props => getOrderTotalCharge({ ...props, part: 'dollars', caloricUnitsSupport: true }),
          x: 135,
          y: 240,
          width: 17,
          textAlign: 'right',
          normalize: normalize.number,
          chargeField: true,
        },
        {
          name: 'Total charge cents',
          type: 'text',
          getValue: props => getOrderTotalCharge({ ...props, part: 'cents', caloricUnitsSupport: true }),
          x: 153,
          y: 240,
          width: 7,
          maxLength: 2,
          normalize: normalize.number,
          chargeField: true,
        },
        {
          name: 'Amount paid dollars',
          type: 'text',
          getValue: props => getDefault({ ...props, defaultValue: '0' }),
          x: 163.5,
          y: 240,
          width: 14,
          textAlign: 'right',
          normalize: normalize.number,
        },
        {
          name: 'Amount paid cents',
          type: 'text',
          getValue: props => getDefault({ ...props, defaultValue: '00' }),
          x: 178,
          y: 240,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Rsrvd for NUCC Use dollars',
          type: 'text',
          x: 184.5,
          y: 240,
          width: 16,
          textAlign: 'right',
          normalize: normalize.number,
        },
        {
          name: 'Rsrvd for NUCC Use cents',
          type: 'text',
          x: 201.5,
          y: 240,
          width: 6,
          maxLength: 2,
          normalize: normalize.number,
        },
        {
          name: 'Provider Name',
          type: 'text',
          getValue: getInquiringProviderUserName,
          x: 8,
          y: 254,
          width: 53,
          height: 8.3,
          multiline: true,
        },
        {
          name: 'Provider Sign',
          type: 'signature',
          x: 17,
          y: 260,
          width: 24,
          height: 8,
        },
        {
          name: 'Provider Date',
          type: 'text',
          getValue: props => getOrderLineDosFrom({ ...props, index: 0 }),
          x: 48,
          y: 261,
          width: 14,
          normalize: normalize.date,
        },
        {
          name: 'Service Facility location information',
          type: 'text',
          getValue: getFacilityNameAndAddress,
          x: 64,
          y: 246,
          width: 66,
          height: 15.3,
          multiline: true,
        },
        {
          name: 'Service Facility location information a)',
          type: 'text',
          getValue: getBusinessNPI,
          x: 65,
          y: 261,
          width: 27,
        },
        {
          name: 'Service Facility location information b)',
          type: 'text',
          x: 93,
          y: 261,
          width: 37,
        },
        {
          name: 'Billing Provider Info',
          type: 'text',
          getValue: getBusinessNameAndAddress,
          x: 132,
          y: 246,
          width: 75,
          height: 15.3,
          multiline: true,
        },
        {
          name: 'Billing Provider Info a)',
          type: 'text',
          getValue: getBusinessNPI,
          x: 133,
          y: 261,
          width: 27,
        },
        {
          name: 'Billing Provider Info b)',
          type: 'text',
          x: 161,
          y: 261,
          width: 46,
        },
      ],
    },
  ],
};

export default Form1500;



// WEBPACK FOOTER //
// ./src/config/documents/Form1500.js